import SharedGlobalStyles from '@helios/shared/styles/shared-global-styles'

import 'gatsby-plugin-prismic-previews/dist/styles.css'

export default SharedGlobalStyles
